import React from "react";
import { Building2, Factory, Phone, UserSearch } from "lucide-react";
import { APOLLO_DEFAULT_FILTERS, ApolloFilterFields, linkedinCategories } from "@/shared/utils/contactConfig";

export const PROSPECT_ROUTE = "/prospecting";

export const PROSPECT_PAGE_TABS = [
  { key: "accounts", title: "Accounts", icon: <Building2 size={16} strokeWidth={2} /> },
  { key: "contacts", title: "Contacts", icon: <UserSearch size={16} strokeWidth={2} /> }
];

export const PROSPECT_DISCOVER_SUGGESTIONS = [
  {
    label: "VP of Sales or CRO at Series A-C SaaS companies in the US with 50-200 employees",
    value: "vp_sales_cro_saas_us",
  },
  {
    label: "Engineering Managers and Tech Leads in Bengaluru with expertise in React & Python",
    value: "eng_managers_react_python_bengaluru",
  },
  {
    label: "Chief Information Security Officers (CISO) at healthcare & fintech enterprises in the UK",
    value: "ciso_healthcare_fintech_uk",
  },
  {
    label: "Marketing Directors at consumer brands that recently raised funding",
    value: "marketing_directors_consumer_funding",
  },
];

/** How many example searches the search screen shows. */
export const EXAMPLE_SEARCH_LIMIT = 3;
/** Saved searches shown before "Show all". */
export const SAVED_SEARCH_PREVIEW_LIMIT = 3;

export const PROSPECT_PAGE_SIZE = 25;

// The Find page's filter panel: the Contacts drawer's fields plus Industry (LinkedIn's list)
// and Has Phone Number.
const INDUSTRY_FILTER_FIELD = {
  id: 7,
  key: "industry",
  title: "Industry",
  icon: <Factory size={16} className="text-gray-700 dark:text-gray-300" />,
  type: "dropDown",
  placeholder: "Type or pick an industry",
  options: linkedinCategories,
};
const sizeIndex = (ApolloFilterFields as Array<{ key: string }>).findIndex((f) => f.key === "company_size");
const HAS_PHONE_FILTER_FIELD = {
  id: 8,
  key: "has_phone",
  title: "Has Phone Number",
  icon: <Phone size={16} className="text-gray-700 dark:text-gray-300" />,
  type: "toggle",
};
const fields = ApolloFilterFields as Array<{ key: string }>;
const withIndustry = [...fields.slice(0, sizeIndex + 1), INDUSTRY_FILTER_FIELD, ...fields.slice(sizeIndex + 1)];
const afterEmail = withIndustry.findIndex((f) => f.key === "has_work_email") + 1;
// Industry after Company Size; Has Phone Number right after Has Work Email.
export const PROSPECT_FILTER_FIELDS = [
  ...withIndustry.slice(0, afterEmail),
  HAS_PHONE_FILTER_FIELD,
  ...withIndustry.slice(afterEmail),
];
export const PROSPECT_DEFAULT_FILTERS: Record<string, any> = {
  ...APOLLO_DEFAULT_FILTERS,
  industry: [],
  has_phone: false,
};

/** Toggles that only filter the results already found (no new search needed). */
export const CONTACT_INFO_FILTER_KEYS = ["has_work_email", "has_phone"];

export const PROSPECT_TABLE_PROPS = {
  rowsPerPage: PROSPECT_PAGE_SIZE,
  height: "calc(100dvh - 274px)",
  tableLayout: "fixed",
  fitToWidth: true,
  headerColor: "bg-[#F7F9FA] dark:bg-gray-800",
  headerClassName: "text-sm font-medium text-gray-900 dark:text-gray-300 dark:border-gray-800",
  headerLabelClassName: "font-medium",
} as const;

export const PROSPECT_SKELETON_ROWS = Array.from({ length: 8 }).map((_, i) => ({
  id: `skeleton-${i}`,
  _isSkeleton: true,
}));

